





















import { Component, Prop, Vue } from 'vue-property-decorator'
import ProConfig from '@/config/config'

@Component({
  name: 'SidebarLogo'
})
export default class extends Vue {
  @Prop({ required: true }) private collapse!: boolean

  private title = '门店云' + ProConfig.getVersion()
}
